/* 
.customTabs .customTabs_item {
    padding: 0px;
    min-width: 0px;
    margin-right: 20px;
    text-transform: inherit;
    font-size: 14px;
    font-weight: 400;
    outline-width: 0px;
}

.customTabs .active {
    color: var(--main-color);
}


.customCard {
    height: 100%;
    max-width: 350px;
    box-shadow: 0px 0px 48px 0px rgba(4, 6, 4, 0.08);
    border-radius: 5px;
    overflow: hidden;
    outline-width: 0px;
}
.customCard .customCard_image {
    height: 140px;
}

.customCard .customCard_title {
    font-weight: 500;
}
.customCard_caption{
    color: darkslategray;
    font-weight: 400;
}





.projectDialog .projectDialog_image {
    max-height: 300px;
    width: 100%;
    object-fit: cover;
    object-position: center center;
}

.projectDialog .projectDialog_description {
    margin-top: 10px;
}

.projectDialog .projectDialog_actions {
    justify-content: center;
    margin-bottom: 10px;
}

.projectDialog .projectDialog_icon {
    color: darkslategray;
    margin: 0px 12px;
    cursor: pointer;
}

.projectDialog .projectDialog_icon :hover {
    color: var(--main-color);
}

.projectDialog .projectDialog_icon > .MuiSvgIcon-root {
    font-size: 30px;
} */

import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles (theme => ({
  section: {
    backgroundColor: '#2d3748',
    color: '#808d9f',
  },
  sectionTitle: {
    position: 'relative',
    padding: '0 3px',
    marginBottom: 20,
    display: 'inline-block',
  },
  span: {
    position: 'absolute',
    height: 7,
    width: '100%',
    bottom: 0,
    opacity: 0.2,
    left: 0,
    backgroundColor: '#bdbdbd',
  },
  sectionTitleText: {
    fontSize: 20,
    fontWeight: 600,
    position: 'relative',
    margin: 0,
  },

  customTabs: {
    marginRight: 20,
    marginBottom: 10,
  },
  customTabsItem: {
    padding: 0,
    minWidth: 0,
    marginRight: 20,
    textTransform: 'inherit',
    fontSize: 14,
    fontWeight: 400,
    outlineWidth: 0,
  },
  customCard: {
    height: '100%',
    maxWidth: 350,
    boxShadow: '0px 0px 48px 0px rgba(4, 6, 4, 0.08)',
    borderRadius: 5,
    overflow: 'hidden',
    outlineWidth: 0,
  },
  customCardImage: {
    height: 140,
  },
  customCardTitle: {
    fontWeight: 500,
    fontFamily: "'Roboto Slab', serif",
  },
  customCardCaption: {
    color: '#bdbdbd',
    fontWeight: 400,
    fontFamily: "'Roboto Slab', serif",
  },

  dialogTitle: {
    backgroundColor: "#2d3748",
    color: "#808d9f",
  },
  dialog: {
    backgroundColor: "#2d3748",
    color: "#bdbdbd",
    
  },
  dialogIcon: {
    color: "#808d9f",
    backgroundColor: "#1a202c",
    "&:hover": {
      backgroundColor: "#1a202c"
    }
  },
  dialogDescription: {
    marginTop: 20,
    fontSize: 15,
    fontFamily: "'Roboto Slab', serif",
  }
}));

export default useStyles;
